/*
 *
 * Package: `@dbh/collapsible-button-theme`.
 *
 */const THEME_KEY_COLLAPSIBLE_BUTTON="collapsibleButton";const modifyCollapsibleButtonTheme=a=>{let{spacing:{sp5:b}}=a;return {[THEME_KEY_COLLAPSIBLE_BUTTON]:{expandStateIndicatorImage:{height:"auto",width:b,verticalAlign:"top"}}}};

export { THEME_KEY_COLLAPSIBLE_BUTTON, modifyCollapsibleButtonTheme as default };
